module.exports = __webpack_public_path__ + "img/iso.1c855260.jpg";